@let incomeTaxEntity$ = this.incomeTaxEntity$ | async;
@if (incomeTaxEntity$) {
  <form [formGroup]="formGroup">
    @if (jaarruimteGegevens.length > 0) {
      <div formArrayName="jaarruimtegegevens">
        @for (item of jaarruimteGegevens.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
              <snelstart-ui-select-form-control [class]="i === 0 ? 'custom-input-250' : 'custom-input-250'"
                                                [label]="i === 0  ? 'Jaar' : ''"
                                                [options]="i === 0 ? jaarRuimteJaar : reserveringsRuimtenJaren"
                                                [required]=true
                                                formControlName="jaar"
                                                id="jaarJR"
              >
              </snelstart-ui-select-form-control>
              <snelstart-ui-number-form-control [class]="i === 0 ? 'custom-input-150' : 'custom-input-150'"
                                                [decimals]="0"
                                                [disabledControl]="hasSpecification(item.controls.jaar.value ?? 0)"
                                                [label]="i === 0 ? 'Ruimte': ''"
                                                align="right"
                                                formControlName="jaarruimte"
                                                id="jaarruimte"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-button (click)="this.showDialog(i)"
                                   [class]="i === 0 ? 'custom-input-150 pt-3' : 'custom-input-150'"
                                   icon="plus"
                                   type="secondary">
                Rekenhulp
              </snelstart-ui-button>
              <snelstart-ui-button (click)="verwijderRij(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                   class="delete"
                                   icon="trash"
                                   iconType="light"
                                   id="buttonDeleteJaarruimteGegevensJr"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        }
      </div>
    }
    @if (jaarruimteGegevens.length === 0) {
      <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus"
                           type="link">Jaarruimte invullen
      </snelstart-ui-button>
    } @else {
      <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus"
                           type="link">Reserveringsruimte toevoegen
      </snelstart-ui-button>
    }
  </form>

  <snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="dialogJaarruimte" size="lg"
                                  title="Specificatie jaarruimte {{dialogJaar}}">
    <snelstart-ui-dialog-header-content>
      Let op! Voor de berekening van de jaarruimte over {{ dialogJaar }} zijn de bedragen uit het
      voorafgaande jaar relevant. Vul dus onderstaande de gegevens over {{ dialogJaar - 1 }} in.
    </snelstart-ui-dialog-header-content>
    <snelstart-ui-dialog-body>
      <form [formGroup]="formGroup">
        @if (jaarruimteGegevens.length > 0) {
          <div formArrayName="jaarruimtegegevens">
            @for (item of jaarruimteGegevens.controls; track item; let i = $index) {
              <div [formGroupName]="i">
                @if (i === this.index) {
                  <div class="row">
                    <div class="col-7">
                      <p>Winst uit onderneming in {{ dialogJaar - 1 }}</p>
                    </div>
                    <div class="col-5">
                      <snelstart-ui-number-form-control [decimals]="0"
                                                        align="right"
                                                        class="custom-input-150"
                                                        formControlName="winstUitOnderneming"
                                                        id="winstUitOndernemingJr"
                                                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                  </div>
                  @if (item.controls.winstUitOnderneming.value !== null) {
                    <div class="row">
                      <div class="col-7">
                        <p>Toevoeging aan de oudedagsreserve in {{ dialogJaar - 1 }}</p>
                      </div>
                      <div class="col-5">
                        <snelstart-ui-number-form-control [decimals]="0"
                                                          [disabledControl]="true"
                                                          align="right"
                                                          class="custom-input-150"
                                                          formControlName="toevoegingFor"
                                                          id="toevoegingForJr"
                                                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-7">
                        <p>Afname van de oudedagsreserve in {{ dialogJaar - 1 }}</p>
                      </div>
                      <div class="col-5">
                        <snelstart-ui-number-form-control [decimals]="0"
                                                          align="right"
                                                          class="custom-input-150"
                                                          formControlName="afnemingFor"
                                                          id="afnemingForJr"
                                                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                      </div>
                    </div>
                  }
                  <div class="row">
                    <div class="col-7">
                      <p>Totaal belastbaar loon in {{ dialogJaar - 1 }}</p>
                    </div>
                    <div class="col-5">
                      <snelstart-ui-number-form-control [decimals]="0"
                                                        align="right"
                                                        class="custom-input-150"
                                                        formControlName="belastbaarLoon"
                                                        id="belastbaarLoonJr"
                                                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                  </div>
                  @if (item.controls.belastbaarLoon.value !== null) {
                    <div class="row">
                      <div class="col-7">
                        <p>Pensioenaangroei (Factor A) in {{ dialogJaar - 1 }}</p>
                      </div>
                      <div class="col-5">
                        <snelstart-ui-number-form-control [decimals]="0"
                                                          align="right"
                                                          class="custom-input-150"
                                                          formControlName="factorA"
                                                          id="factorAJr"
                                                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                      </div>
                    </div>
                  }
                  <div class="row">
                    <div class="col-7">
                      <p>Resultaat uit overige werkzaamheden (incl. TBS) in {{ dialogJaar - 1 }}</p>
                    </div>
                    <div class="col-5">
                      <snelstart-ui-number-form-control [decimals]="0"
                                                        align="right"
                                                        class="custom-input-150"
                                                        formControlName="belastbaarROW"
                                                        id="belastbaarROWJr"
                                                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-7">
                      <p>Belastbare periodieke uitkeringen in {{ dialogJaar - 1 }}</p>
                    </div>
                    <div class="col-5">
                      <snelstart-ui-number-form-control [decimals]="0"
                                                        align="right"
                                                        class="custom-input-150"
                                                        formControlName="belastbarePU"
                                                        id="belastbarePUJr"
                                                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-7">
                      <p>Netto pensioen in {{ dialogJaar - 1 }}</p>
                    </div>
                    <div class="col-5">
                      <snelstart-ui-number-form-control [decimals]="0"
                                                        align="right"
                                                        class="custom-input-150"
                                                        formControlName="premiesNettoPensioen"
                                                        id="premiesNettoPensioenJr"
                                                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                  </div>
                  @if(dialogJaar != incomeTaxEntity$.aangifte?.aangifteJaar) {
                    <div class="row">
                        <div class="col-7">
                            <p>Al benutte jaarruimte {{ dialogJaar }}</p>
                        </div>
                        <div class="col-5">
                            <snelstart-ui-number-form-control [decimals]="0"
                                                              align="right"
                                                              class="custom-input-150"
                                                              formControlName="afgetrokkenPremie"
                                                              id="afgetrokkenPremie"
                                                              prefix="€"
                            >
                            </snelstart-ui-number-form-control>
                        </div>
                    </div>
                  }
                }
              </div>
            }
          </div>
        }
      </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
      <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
      <snelstart-ui-button (click)="getRapport(incomeTaxEntity$.aangifte!)" icon="check" id="save" type="primary">
        Bereken
      </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
  </snelstart-ui-dialog-definition>
}
